var map = {
	"./AccountDelete.svg": "6a2b",
	"./AccountSet.svg": "47ab",
	"./EscrowCancel.svg": "55c9a",
	"./EscrowCreate.svg": "80d1",
	"./EscrowFinish.svg": "684b",
	"./OfferCancel.svg": "b3c6",
	"./OfferCreate.svg": "5ee7",
	"./Payment.svg": "8ec0",
	"./PaymentChannelClaim.svg": "0866",
	"./PaymentChannelCreate.svg": "bf5b",
	"./PaymentChannelFund.svg": "2b9c",
	"./SetRegularKey.svg": "27f3",
	"./SignerListSet.svg": "c6e5",
	"./TrustSet.svg": "527f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1150";